<template>
<div class="bb-order">
    <div class="renewContent">
        <div class="tip">适合各类“品牌商+团长”零售活动，例如品牌商家、供应商、生产基地、线下实体商家、团购公司、生活类服务商家、自媒体商家等。</div>
        <div class="tips">
            <div class="row"><i class="spot"></i>“品牌商+团长”零售活动：品牌商发布开团活动，设置好后，只需一键发给团长一键复制即可，非常便捷！</div>
            <div class="row"><i class="spot"></i>品牌商管理后台：轻量化的H5端品牌商管理后台，分级灵活管理团长，独立设置团长佣金、团长推荐佣金，按活动、按团长单独发放佣金。各种用户数据可视化分析，活动效果清晰可见。</div>
            <div class="row"><i class="spot"></i>商品库便捷管理：独立设置商品佣金、团购价格，整体管理商品库存，商品管理有条不紊！</div>
            <div class="row"><i class="spot"></i>收支清晰实时：各个活动、各个团长、各种名义的收入支出一目了然！</div>
        </div>
    </div>
    <div class="renewContrainer">
        <div  :class="'contrainer '+ code(obj.code)" v-for="(obj,index) in dataList" :key="index">
            <div class="sort">{{obj.name}}</div>
            <div class="content">
                <div class="box">
                    <span class="name">品牌商账户</span>
                    <span class="value">{{obj.hostcount}}个</span>
                </div>
                <div class="box">
                    <span class="name">团长主页名额</span>
                    <span class="value t-orange">{{obj.headercount?obj.headercount+'个':'不限'}}</span>
                </div>
                <div class="box">
                    <span class="name">微信支付商户号</span>
                    <span class="value">{{obj.iscustompay?'支持':'不支持'}}</span>
                </div>
                <div class="box">
                    <span class="name">平台服务费</span>
                    <span class="value t-orange">{{obj.servicerate?'销售收入×'+ obj.servicerate + '%': obj.servicerate}}</span>
                </div>
                <div class="box">
                    <span class="name">特色功能</span>
                    <span class="value t-orange">{{obj.memo}}</span>
                </div>
            </div>
            <div class="expiredays"><span v-if="brandinfo.code==obj.code">{{expiredate(obj.code)}}</span></div>
            <div class="renewOrder custom" v-if="obj.saleprice=='0'">
                <div class="saleprice">面议</div>
            </div>
            <div class="renewOrder" v-else>
                <div class="saleprice"><span class="sign">￥</span><span class="num">{{obj.saleprice}}</span><span class="unit">/年</span></div>
                <div class="uprice">￥{{obj.uprice}}</div>
                <div class="renewBtn"><el-button type="primary" @click="handleOrder(obj)">立即订购</el-button></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getBrandVersionInfo, uploadHostRolePriceOrderInfo} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import {brandBusiness} from 'api/enumCode'
export default {
    name: 'Renew',
    data() {
        return {
            dataList: [],
            param: {
                code: ''
            },
            brandinfo: {
                code: ''
            }
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleOrder(row) {
            this.param.code = row.code
            this._save()
        },
        _save() {
            this.setLoading(true)
            uploadHostRolePriceOrderInfo({
                data: this.param,
                success: data => {
                    this.setLoading(false)
                    // window.open(data.data.payurl)
                    window.location.href = data.data.payurl
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getBrandVersionInfo({
                data: this.param,
                success: data => {
                    this.dataList = data.data.datalist
                    this.brandinfo.code = data.data.brandinfo.code
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        expiredate () {
            return function(value) {
                let str = ''
                let now = new Date()
                value= new Date(this.brandBusiness.expiredate)
                if (now > value) {
                    let num = (now-value)/1000/60/60/24
                    str = `已过期${num.toFixed(0)}`
                } else {
                    let num = (value-now)/1000/60/60/24
                    str = `还有${num.toFixed(0)}天过期`
                }
                return str
            }
        },
        code() {
            return function (value) {
                for (let i = 0; i < brandBusiness.version.length; i++) {
                    if (value === brandBusiness.version[i].code) {
                        return brandBusiness.version[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters(['brandBusiness', 'shop', 'user'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
.bb-order {
    background: #fff;
    padding-bottom: 200px;
    .renewContent{
        font-size: 16px;
        padding-top: 30px;
        .tip{
            background:  #F5F7FA;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 60px;
            border-radius: 10px;
            line-height: 20px;
            color: #606266;
            width: 1200px;
            margin: auto;
        }
        .tips{
            width: 1200px;
            margin: auto;
            color:  #303133 ;
            line-height: 24px;
            .row{
                margin-top: 15px;
                display: flex;
            }
            .spot{
                display: inline-block;
                width: 15px;
                min-width: 15px;
                height: 15px;
                border-radius: 50%;
                background: #409EFF;
                margin-right: 20px;
            }
        }
    }
    .renewContrainer{
        margin-top: 60px;
        min-width: 1200px;
        display: flex;
        justify-content: center;
        .contrainer{
            width: 340px;
            max-width: 340px;
            background:rgba(255,255,255,1);
            border-radius:4px;
            border: 1px solid #DCDFE6;
            &:hover{
                box-shadow:0px 8px 24px 0px rgba(82,94,102,0.15);
                border-color: transparent;
            }
            .sort{
                height: 104px;
                line-height: 104px;
                color: #fff;
                text-align: center;
                font-size: 36px;
            }
        }
        .cls1 .sort{
            background: #2FAFFF;
        }
        .cls2 .sort{
            background: #407EFE;
        }
        .cls3 .sort{
            background:  #FFA940 ;
        }
        .cls4{
            .sort{
                background:linear-gradient(225deg,rgba(131,129,126,1) 0%,rgba(0,0,0,1) 100%);
            }
            .t-orange{
                color: #FFA940 !important;
            }
        }
        .contrainer+.contrainer{
            margin-left: 30px;
        }
        .content{
            padding:25px 20px 0 40px;
            .box{
                display: flex;
                height: 50px;
                align-items: center;
                justify-content: space-between;
                font-size: 16px;
                .name{
                    color: #606266;
                }
                .value{
                    color: #409EFF;
                }
            }
        }
        .expiredays{
            height: 120px;
            color: #F56C6C;
            padding-bottom: 30px;
            box-sizing: border-box;
            border-bottom: 1px solid #DCDFE6;
            display: flex;
            justify-content: center;
            align-items: flex-end;
        }
        .renewOrder{
            padding: 30px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            font-size: 20px;
            .saleprice{
                color: #303133;
                display: flex;
                .sign{
                    align-self: flex-start;
                }
                .num{
                    font-size: 40px;
                    margin: 0 6px;
                }
                .unit{
                    color:  #909399;
                    align-self: flex-end;
                }
            }
            .uprice{
                color:  #909399;
                margin-top: 8px;
                text-decoration:line-through;
            }
            .renewBtn{
                margin-top: 30px;
                .el-button{
                    width:144px;
                    height:50px;
                    background:linear-gradient(135deg,rgba(64,126,254,1) 0%,rgba(47,175,255,1) 100%);
                    border-radius:4px;
                }
            }
        }
    }
    .custom{
        height: 208px;
        line-height: 148px;
        box-sizing: border-box;
        font-size: 40px !important;
    }
}
</style>
